import getConfig from "src/config/appConfig";
import agendaApiConfig from "./agendaApiConfig";

const ExamenService = {
  async getExamenes(codeExamen = 0) {
    const { IMAGENOLOGIA } = getConfig();
    let query = {};
    if (IMAGENOLOGIA == "") {
      query = null;
    } else {
      query = { ser_codigo: IMAGENOLOGIA };
    }

    return await agendaApiConfig.get(`/imagenologia/${codeExamen}/examen`, {
      params: {
        ...query,
      },
    });

    //return await agendaApiConfig.get(`/imagenologia/${codeExamen}/examen`);
  },
};

export default ExamenService;
